"use strict";
exports.__esModule = true;
exports.StatusPillType = void 0;
var StatusPillType;
(function (StatusPillType) {
    StatusPillType["Light"] = "light";
    StatusPillType["Dark"] = "dark";
    StatusPillType["Success"] = "success";
    StatusPillType["Issue"] = "issue";
    StatusPillType["Failure"] = "failure";
    StatusPillType["Brand"] = "brand";
    StatusPillType["Info"] = "info";
    StatusPillType["Green"] = "green";
})(StatusPillType = exports.StatusPillType || (exports.StatusPillType = {}));
